// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockument .blockument-column-container {
   display: flex;
   flex-direction: row;
   width: 100%;
   overflow-x: auto;
}

.blockument .blockument-column-container .blockument-column {
   padding: var(--padding);
   overflow-x: auto;
   min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/Columns.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;GACnB,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,uBAAuB;GACvB,gBAAgB;GAChB,gBAAgB;AACnB","sourcesContent":[".blockument .blockument-column-container {\r\n   display: flex;\r\n   flex-direction: row;\r\n   width: 100%;\r\n   overflow-x: auto;\r\n}\r\n\r\n.blockument .blockument-column-container .blockument-column {\r\n   padding: var(--padding);\r\n   overflow-x: auto;\r\n   min-width: 100px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
